module.exports = __webpack_public_path__ + "img/designer_flow.398487a4.png";